<template>

  <fieldset>
    
    <div class="form-wrap">
      
      <div>
        <label for="policy_day_start">Policy Day Start</label>
        <input type="text" id="policy_day_start" v-model="$parent.newPolicy.days_before_start" v-on:keyup="checkDaysStart">
      </div>

      <div>
        <label for="policy_day_end">Policy Day End</label>
        <input type="text" id="policy_day_end" v-model="$parent.newPolicy.days_before_end" v-on:keyup="checkDaysEnd">
      </div>      

      <div>
        <label for="percentage">Check box for percentage</label>
        <input type="checkbox" id="percentage" v-model="$parent.newPolicy.penalty_type">
      </div>

      <div>
        <label for="cancellationAmount">Cancellation Amount</label>
        <input type="text" id="cancellationAmount" v-model="$parent.newPolicy.penalty_charge" v-on:keyup="checkAmount">
      </div>

      <div>
        <label for="tourType">Tour Type</label>
        <select id="tourType" v-model="$parent.newPolicy.tour_type">
          <option value="air">Air</option>
          <option value="coach">Coach</option>
        </select>
      </div>
    
    </div>

  </fieldset>
</template>

<script>

import axios from 'axios';
export default {
  name: "AddPolicyFields",
  methods:{
    checkAmount(){
      if((this.$parent.newPolicy.penalty_charge > 100) && this.$parent.newPolicy.penalty_type){
        this.$parent.newPolicy.penalty_charge = 100
        this.$notify({
          type: 'error',
          title: 'Sorry! You cannot enter more than 100%'
        });
      }
    },
    checkDaysEnd(){
      if (Number(this.$parent.newPolicy.days_before_end) > Number(this.$parent.newPolicy.days_before_start)) {
        // this.$parent.newPolicy.days_before_end = null
        this.$parent.btnDisabled = false
        this.$notify({
          type: 'error',
          title: 'Days end should be less than days start.'
        });
      }else{
        this.$parent.btnDisabled = true
      }
    },
    checkDaysStart(){
      if (Number(this.$parent.newPolicy.days_before_end)) {

        if (Number(this.$parent.newPolicy.days_before_start) < Number(this.$parent.newPolicy.days_before_end)) {
          this.$parent.btnDisabled = false
          this.$notify({
            type: 'error',
            title: 'Days start should be greater than days end.'
          });
        }else{
          this.$parent.btnDisabled = true
        }
      }
    }
  }
};
</script>